export default __webpack_public_path__ + "static/media/favicon-lumpsum.93e34038.ico";